import { capitalize, lowerCase } from "lodash";
import { useState } from "react";
import { Button } from "../../Button";
import { Dialog } from "../../Dialog";
import { Label } from "../../Label";
import { TextInput } from "../../TextInput";

type DuplicateDialogProps = {
  resourceName: string;
  open: boolean;
  onOpenChange: (value: boolean) => void;
  onConfirm: (name: string) => void;
  defaultName: string;
};

export const DuplicateDialog = ({
  resourceName,
  open,
  onOpenChange,
  onConfirm,
  defaultName,
}: DuplicateDialogProps) => {
  const [name, setName] = useState(defaultName);

  return (
    <Dialog.Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Title>Clone {capitalize(resourceName)}</Dialog.Title>
        <Dialog.Description>
          This will create another version of this ${lowerCase(resourceName)} and open it in the
          builder. Do you wish to proceed?
        </Dialog.Description>
        <div className="mt-4">
          <Label htmlFor="NewResourceName">Name</Label>
          <TextInput
            value={name}
            onValueChange={(e) => setName(e.target.value)}
            id={"NewResourceName"}
          />
        </div>
        <Dialog.Footer>
          <Dialog.Close>
            <Button
              variant="primary"
              text={`Clone ${capitalize(resourceName)}`}
              onClick={() => onConfirm(name)}
            />
          </Dialog.Close>
          <Dialog.Close>
            <Button variant="ghost" text="Cancel" />
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Dialog>
  );
};
